module.exports = __webpack_public_path__ + "assets/img/email.704d71a5.svg";